import LaycanEditor from '../grid/editors/LaycanEditor';
import LaycanFormatter from '../grid/formatters/LaycanFormatter';
import LaycanKeyCreator from '../grid/keyCreators/LaycanKeyCreator';
import LaycanValueGetter from '../grid/valueGetters/LaycanValueGetter';
import {
    LaycanComparator,
    LaycanFromComparator,
} from '../grid/comparators/LaycanComparator';

import LocationEditor from '../grid/editors/LocationEditor';
import LocationsFormatter from '../grid/formatters/LocationsFormatter';
import LocationPartsComparator from '../grid/comparators/locationPartsComparator';
import LocationPartsKeyCreator from '../grid/keyCreators/LocationPartsKeyCreator';

import { cargoQuantityPartsHeading } from '_legacy/modules/columns/quantity';
import { durationPartsHeading } from '_legacy/modules/columns/duration';
import { clarksonsBrokerHeadingForOrders } from '_legacy/modules/columns/clarksonsBroker';
import { updatedByHeading } from '_legacy/modules/columns/updatedBy';
import { orderStatusHeading } from '_legacy/modules/columns/orderStatus';

import NamePropertyComparator from '../grid/comparators/NamePropertyComparator';
import CompanyFormatter from '_legacy/modules/shared/columns/formatters/CompanyFormatter';
import CompanyKeyCreator from '_legacy/modules/shared/columns/keyCreators/CompanyKeyCreator';
import ChartererEditor from '../grid/editors/ChartererEditor';
import GroupNameRenderer from '../grid/renderers/GroupNameRenderer';

import ZoneEditor from '../grid/editors/ZoneEditor';
import ZoneComparator from '../grid/comparators/ZoneComparator';

import TypeFormatter, {
    AllTypeFormatter,
} from '../grid/formatters/TypeFormatter';

import TooltipRenderer from '../grid/renderers/TooltipRenderer';

import suppressOnEdit from '../grid/columnDefaults/suppressOnEdit';
import allowUpAndDownOnEdit from '../grid/columnDefaults/allowUpAndDownOnEdit';
import defaultObjEquals from '../grid/columnDefaults/defaultObjEquals';

import CargoEditor from '../grid/editors/CargoEditor';
import MultipleCargoFormatter from '../grid/formatters/MultipleCargoFormatter';
import CargoPartsComparator from '../grid/comparators/CargoPartsComparator';
import CargoPartsKeyCreator from '../grid/keyCreators/CargoPartsKeyCreator';

import MultipleFreightPortBasisFormatter from '../grid/formatters/MultipleFreightPortBasisFormatter';
import FreightPortBasisEditor from '../grid/editors/FreightPortBasisEditor';
import MultiFreightPortBasisComparator from '../grid/comparators/MultiFreightPortBasisComparator';
import FreightPortBasisKeyCreator from '../grid/keyCreators/FreightPortBasisKeyCreator';

import BrokerEditor from '../grid/editors/BrokerEditor';
import MultipleCompanyFormatter from '../grid/formatters/MultipleCompanyFormatter';
import BrokersComparator from '../grid/comparators/BrokersComparator';
import BrokersKeyCreator from '../grid/keyCreators/BrokersKeyCreator';
import { commonRowAndCellClassRules } from '../grid/classRules/classRules';
import LaycanFromFormatter from '../grid/formatters/LaycanFromFormatter';

import naturalSortComparator from '../grid/comparators/NaturalSortComparator';
import BlanksFilterRenderer from '../grid/renderers/BlanksFilterRenderer';
import defaultSetFilterParams from '../grid/columnDefaults/defaultSetFilterParams';
import SelectEditor from '_legacy/modules/shared/columns/editors/SelectEditor';

import VisibilityRenderer from '../grid/renderers/VisibilityRenderer';
import QuotedFormatter, {
    QuotedFieldFormatter,
} from '../grid/formatters/QuotedFormatter';
import QuotedKeyCreator from '../grid/keyCreators/QuotedKeyCreator';
import { areasByDataset, getAreasGeared } from '../../models/Areas';
import CommissionEditor from '../grid/editors/CommissionEditor';
import ParcelsEditor from '../grid/editors/ParcelsEditor';

import ThirdPartyBrokerEditor from '../grid/editors/ThirdPartyBrokerEditor';
import MultipleThirdPartyCompanyFormatter from '../grid/formatters/MultipleThirdPartyCompanyFormatter';

import DirectionValueGetter from '../grid/valueGetters/DirectionValueGetter';

import {
    SEPARATOR_FORWARD_SLASH,
    SEPARATOR_PLUS,
} from '../../models/common/EntityPart';
import CommissionFormatter from '../grid/formatters/CommissionFormatter';
import CommissionComparator from '../grid/comparators/CommissionComparator';
import CommissionKeyCreator from '../grid/keyCreators/CommissionKeyCreator';
import { ratesHeadingForOrders } from '_legacy/modules/columns/rate';

import {
    vesselCategoryHeading,
    vesselNameHeadingForOrders,
} from '_legacy/modules/columns/vessel';
import { thirdPartyOwnerHeadingForOrders } from '_legacy/modules/columns/thirdPartyOwner';
import { thirdPartyChartererHeading } from '_legacy/modules/columns/thirdPatyCharterer';

import {
    unassignedAreaText,
    unassignedAreaGearedText,
    unassignedDirectionText,
    unassignedChartererText,
} from '_legacy/constants/gridText';
import { getDataset } from '_legacy/models/Datasets';
import { orderDeliveryTermHeading } from '_legacy/modules/columns/deliveryTerm';
import { orderRedeliveryTermHeading } from '_legacy/modules/columns/redeliveryTerm';
import {
    formatSalePrice,
    parseSalePrice,
} from '_legacy/services/SalePriceFormatterService';
import { SalePriceComparator } from '_legacy/modules/columns/quantity/comparators/SalePriceComparator';
import { buyerHeading } from '_legacy/modules/columns/buyer/heading/buyerHeading';
import { opportunityHeading } from '_legacy/modules/columns/opportunity/heading/opportunityHeading';
import { operatorHeading } from '_legacy/modules/columns/operator/headings/operatorHeading';
import { typesByDataset } from '_legacy/models/Type';
import PriceEditor from '../grid/editors/PriceEditor';
import { formatAwrp, parseAwrp } from '_legacy/services/AwrpFomatterService';
import TypeKeyCreator from '_legacy/modules/shared/columns/keyCreators/TypeKeyCreator';
import chartererTypeHeading from '_legacy/modules/columns/chartererType/chartererTypeHeading';
import nearForwardHeading from '_legacy/modules/columns/nearForward/nearForwardHeading';
import { TypeSortComparator } from '_legacy/modules/shared/columns/comparators/TypeSortComparator';
import { getEastWestHeading } from '_legacy/modules/columns/eastWest/EastWestHeading';
import intraInterRegionalHeading from '_legacy/modules/columns/intraInterRegional/intraInterRegionalHeading';
import { reportedDateHeading } from '_legacy/modules/columns/reportedDate/ReportedDateHeading';
import { getSaleDateHeading } from '_legacy/modules/columns/saleDate/SaleDateHeading';
import { getHireExpiryHeading } from '_legacy/modules/columns/hireExpiry/HireExpiryHeading';
import { updatedTimeHeading } from '_legacy/modules/columns/updatedDateTime/UpdatedDateTimeHeading';
import { createdDateHeading } from '_legacy/modules/columns/createdDate/CreatedDateHeading';
import { laycanToHeading } from '_legacy/modules/columns/laycanTo/LaycanToHeading';
import { getMinRedeliveryHeading } from '_legacy/modules/columns/minRedelivery/MinRedeliveryHeading';
import { getMaxRedeliveryHeading } from '_legacy/modules/columns/maxRedelivery/MaxRedeliveryHeading';
import { formatDisplayZones } from 'common/types/GetDisplayZone';
import ZoneKeyCreator from '../grid/keyCreators/ZoneKeyCreator';
import LoadZoneKeyCreator from '../grid/keyCreators/LoadZoneKeyCreator';

const isEditableRow = (params) => {
    const isEditable =
        params &&
        params.data &&
        params.data.state !== 'Deleted' &&
        params.data.state !== 'Converted' &&
        params.data.state !== 'Withdrawn' &&
        params.context.canEdit;

    return isEditable;
};

const isEditableNonSpecialisedRow = (params) =>
    isEditableRow(params) && params.context.datasetId !== 13;

const saleDateHeading = getSaleDateHeading(isEditableRow);
const hireExpiryHeading = getHireExpiryHeading(isEditableRow);
const minRedelivery = getMinRedeliveryHeading(
    false,
    'Read-only, auto-calculated based on L/C and firm Duration'
);
const maxRedelivery = getMaxRedeliveryHeading(
    false,
    'Read-only, auto-calculated based on L/C and firm Duration'
);

const checkboxHeading = {
    colId: 'isSelected',
    pinned: 'left',
    headerName: '',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    lockPinned: true,
    suppressMenu: true,
    suppressMovable: true,
    lockPosition: 'left',
    suppressColumnsToolPanel: true,
    width: 24,
    minWidth: 35,
    enableCellChangeFlash: false,
};

const privacyHeading = {
    colId: 'privacy',
    headerName: '',
    headerValueGetter: (params) =>
        params.location === 'columnToolPanel' ? 'Visibility' : '',
    columnToolPanelLabel: 'Visibility',
    field: 'privacy',
    editable: false,
    cellRendererFramework: VisibilityRenderer,
    headerClass: 'grid-heading-privacy',
    cellClass: 'grid-cell-privacy',
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filter: 'visibilityFilter',
    width: 60,
    minWidth: 60,
};

const salePriceHeading = {
    colId: 'salePrice',
    headerName: 'Sale Price',
    field: 'salePrice',
    editable: true,
    cellEditorFramework: PriceEditor,
    cellEditorParams: {
        valueParser: (value) => parseAwrp(value),
        valueFormatter: (value) => formatAwrp(value),
    },
    sortable: true,
    hide: true,
    type: ['privatable'],
    width: 150,
    valueFormatter: (params) => formatSalePrice(params.value),
    comparator: SalePriceComparator,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filter: 'agMultiColumnFilter',
    filterParams: {
        filters: [
            {
                filter: 'priceFilter',
                filterParams: {
                    ...defaultSetFilterParams,
                    valueParser: (params) => parseSalePrice(params.value),
                },
            },
            {
                filter: 'agSetColumnFilter',
                filterParams: {
                    ...defaultSetFilterParams,
                    comparator: SalePriceComparator,
                    refreshValuesOnOpen: true,
                    suppressRemoveEntries: true,
                    cellRenderer: BlanksFilterRenderer,
                    valueFormatter: (params) =>
                        formatSalePrice(params.value, true),
                },
            },
        ],
    },
};

const chartererHeading = {
    colId: 'charterer',
    headerName: 'Charterer',
    field: 'charterer',
    editable: isEditableRow,
    valueFormatter: CompanyFormatter,
    cellEditorFramework: ChartererEditor,
    suppressKeyboardEvent: suppressOnEdit(),
    comparator: NamePropertyComparator,
    equals: defaultObjEquals,
    keyCreator: (params) =>
        CompanyKeyCreator({ ...params, defaultValue: unassignedChartererText }),
    enableRowGroup: true,
    width: 120,
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
        cellRenderer: BlanksFilterRenderer,
    },
};

const typeHeading = {
    colId: 'type',
    headerName: 'Type',
    field: 'type',
    editable: isEditableRow,
    valueFormatter: TypeFormatter,
    cellEditorFramework: SelectEditor,
    cellEditorParams: {
        valuesByDataset: typesByDataset,
        formatValue: AllTypeFormatter,
    },
    suppressKeyboardEvent: allowUpAndDownOnEdit(),
    width: 67,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
    keyCreator: TypeKeyCreator,
    comparator: TypeSortComparator,
};

const laycanHeading = {
    colId: 'laycan',
    headerName: 'L/C',
    field: 'laycan',
    editable: isEditableRow,
    cellEditorFramework: LaycanEditor,
    valueFormatter: LaycanFormatter,
    valueGetter: LaycanValueGetter,
    comparator: LaycanComparator,
    keyCreator: LaycanKeyCreator,
    equals: defaultObjEquals,
    sort: 'asc',
    filter: 'laycanFilter',
    width: 100,
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
};

const laycanFromHeading = {
    colId: 'laycanFrom',
    headerName: 'L/C From',
    field: 'laycan',
    editable: false,
    width: 80,
    sortable: true,
    suppressMenu: true,
    valueFormatter: LaycanFromFormatter,
    comparator: LaycanFromComparator,
    hide: true,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
    excelExportFormat: 'date',
};

const commentsHeading = {
    colId: 'comments',
    headerName: 'Comments',
    field: 'comments',
    editable: isEditableRow,
    width: 120,
    type: ['privatable'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    cellRenderer: TooltipRenderer,
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
    suppressPaste: false,
};

const dischargeLocationHeading = {
    colId: 'dischargeLocationParts',
    headerName: 'Disch',
    field: 'dischargeLocationParts',
    editable: isEditableRow,
    valueFormatter: LocationsFormatter,
    cellEditorFramework: LocationEditor,
    cellEditorParams: {
        defaultSeperatorCharacter: SEPARATOR_FORWARD_SLASH,
        blockedCharacters: [],
    },
    cellRenderer: (location) =>
        TooltipRenderer({ value: location.valueFormatted }),
    equals: defaultObjEquals,
    suppressKeyboardEvent: suppressOnEdit(),
    comparator: LocationPartsComparator,
    keyCreator: LocationPartsKeyCreator,
    filter: 'locationsFilter',
    width: 120,
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
};

const redeliveryLocationHeading = {
    colId: 'redeliveryLocationParts',
    headerName: 'Redelivery',
    field: 'redeliveryLocationParts',
    editable: isEditableRow,
    cellEditorFramework: LocationEditor,
    cellEditorParams: {
        defaultSeperatorCharacter: SEPARATOR_FORWARD_SLASH,
        blockedCharacters: [],
    },
    cellRenderer: (location) =>
        TooltipRenderer({ value: location.valueFormatted }),
    valueFormatter: LocationsFormatter,
    equals: defaultObjEquals,
    suppressKeyboardEvent: suppressOnEdit(),
    comparator: LocationPartsComparator,
    keyCreator: LocationPartsKeyCreator,
    filter: 'locationsFilter',
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
    width: 120,
    hide: true,
};

const deliveryLocationHeading = {
    colId: 'deliveryLocationParts',
    headerName: 'Delivery',
    field: 'deliveryLocationParts',
    editable: isEditableRow,
    cellEditorFramework: LocationEditor,
    cellEditorParams: {
        defaultSeperatorCharacter: SEPARATOR_FORWARD_SLASH,
        blockedCharacters: [],
    },
    cellRenderer: (location) =>
        TooltipRenderer({ value: location.valueFormatted }),
    valueFormatter: LocationsFormatter,
    equals: defaultObjEquals,
    suppressKeyboardEvent: suppressOnEdit(),
    comparator: LocationPartsComparator,
    keyCreator: LocationPartsKeyCreator,
    filter: 'locationsFilter',
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
    width: 100,
    hide: true,
};

const cargoPartsHeading = {
    colId: 'cargoParts',
    headerName: 'Cgo',
    field: 'cargoParts',
    editable: isEditableRow,
    valueFormatter: MultipleCargoFormatter,
    cellEditorFramework: CargoEditor,
    cellRenderer: (cargo) => TooltipRenderer({ value: cargo.valueFormatted }),
    suppressKeyboardEvent: suppressOnEdit(),
    comparator: CargoPartsComparator,
    equals: defaultObjEquals,
    keyCreator: CargoPartsKeyCreator,
    enableRowGroup: true,
    filter: 'cargoesFilter',
    width: 120,
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
};

const freightPortBasisHeading = {
    colId: 'freightPortBasis',
    headerName: 'Freight Port Basis',
    field: 'freightPortBasis',
    editable: isEditableRow,
    valueFormatter: MultipleFreightPortBasisFormatter,
    cellEditorFramework: FreightPortBasisEditor,
    cellRenderer: (port) => TooltipRenderer({ value: port.valueFormatted }),
    suppressKeyboardEvent: suppressOnEdit(),
    comparator: MultiFreightPortBasisComparator,
    equals: defaultObjEquals,
    keyCreator: FreightPortBasisKeyCreator,
    width: 120,
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
    hide: true,
};

const thirdPartyBrokersHeading = {
    colId: 'thirdPartyBrokers',
    headerName: 'Broker',
    field: 'thirdPartyBrokers',
    editable: isEditableRow,
    valueFormatter: MultipleThirdPartyCompanyFormatter,
    cellEditorFramework: ThirdPartyBrokerEditor,
    cellEditorParams: {
        blockedCharacters: [SEPARATOR_FORWARD_SLASH],
        seperatorCharacters: [SEPARATOR_PLUS],
    },
    cellRenderer: (broker) => TooltipRenderer({ value: broker.valueFormatted }),
    suppressKeyboardEvent: suppressOnEdit(),
    comparator: BrokersComparator,
    equals: defaultObjEquals,
    keyCreator: BrokersKeyCreator,
    width: 120,
    type: ['privatable', 'rumoured'],
    filter: 'companiesFilter',
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
};

const loadLocationHeading = {
    colId: 'loadLocationParts',
    headerName: 'Load',
    field: 'loadLocationParts',
    editable: isEditableRow,
    valueFormatter: LocationsFormatter,
    cellEditorFramework: LocationEditor,
    cellEditorParams: {
        defaultSeperatorCharacter: SEPARATOR_FORWARD_SLASH,
        blockedCharacters: [],
    },
    cellRenderer: (location) =>
        TooltipRenderer({ value: location.valueFormatted }),
    equals: defaultObjEquals,
    suppressKeyboardEvent: suppressOnEdit(),
    comparator: LocationPartsComparator,
    keyCreator: LocationPartsKeyCreator,
    filter: 'locationsFilter',
    width: 120,
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
};

const loadZoneHeading = {
    colId: 'loadZones',
    headerName: 'Load Z',
    field: 'loadZones',
    editable: isEditableNonSpecialisedRow,
    valueFormatter: (params) =>
        formatDisplayZones(params.value, params.data?.loadZone, 'loadZones'),
    enableRowGroup: true,
    cellEditorFramework: ZoneEditor,
    suppressKeyboardEvent: suppressOnEdit(),
    keyCreator: LoadZoneKeyCreator,
    width: 100,
    comparator: ZoneComparator,
    filter: 'zonesFilter',
    type: ['privatable'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
};

const areaHeading = {
    colId: 'areas',
    headerValueGetter: (params) =>
        getDataset(params.context.datasetId).headingsMapping['areas'],
    enableRowGroup: true,
    field: 'areas',
    editable: isEditableNonSpecialisedRow,
    sortable: true,
    cellEditorFramework: SelectEditor,
    cellEditorParams: {
        valuesByDataset: areasByDataset,
    },
    rowGroupIndex: 0,
    keyCreator: ({ value }) => {
        if (!value) {
            return unassignedAreaText;
        }
        return value;
    },
    suppressKeyboardEvent: allowUpAndDownOnEdit(),
    width: 100,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
        cellRenderer: BlanksFilterRenderer,
    },
};

const areaGearedHeading = {
    colId: 'areasGeared',
    headerName: 'Area Geared',
    enableRowGroup: true,
    field: 'areasGeared',
    editable: isEditableRow,
    sortable: true,
    cellEditorFramework: SelectEditor,
    cellEditorParams: {
        valuesByDataset: getAreasGeared,
    },
    rowGroupIndex: 0,
    keyCreator: ({ value }) => {
        if (!value) {
            return unassignedAreaGearedText;
        }
        return value;
    },
    suppressKeyboardEvent: allowUpAndDownOnEdit(),
    width: 100,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
        cellRenderer: BlanksFilterRenderer,
    },
    hide: true,
};

const stateHeading = {
    colId: 'state',
    headerName: 'State',
    field: 'state',
    editable: false,
    sortable: true,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
    hide: true,
    width: 67,
};

const brokerHeading = {
    colId: 'brokers',
    headerName: 'Broker',
    field: 'brokers',
    editable: isEditableRow,
    valueFormatter: MultipleCompanyFormatter,
    cellEditorFramework: BrokerEditor,
    suppressKeyboardEvent: suppressOnEdit(),
    comparator: BrokersComparator,
    equals: defaultObjEquals,
    keyCreator: BrokersKeyCreator,
    width: 120,
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
};

// We need this header in place so that we can use setDataValue() methods for the privateFields (cell privacy)
// column. Otherwise, it's ignored. It is not displayed and cannot be picked from column selector.
//
const privateFieldsHeading = {
    headerName: 'Private Fields',
    field: 'privateFields',
    editable: false,
    hide: true,
    suppressColumnsToolPanel: true,
};

const rumouredHeading = {
    colId: 'rumoured',
    headerName: 'Rumoured',
    field: 'rumoured',
    editable: false,
    hide: true,
    suppressColumnsToolPanel: true,
};

const offersHeading = {
    colId: 'offers',
    headerName: 'Offers',
    field: 'offers',
    editable: isEditableRow,
    width: 120,
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    cellRenderer: TooltipRenderer,
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
    suppressPaste: false,
};

const groupName = {
    headerName: 'Group',
    field: 'groupName',
    editable: false,
    cellRendererFramework: GroupNameRenderer,
    enableRowGroup: true,
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
};

const privateCommentsHeading = {
    headerName: 'Private Comments',
    field: 'privateComments',
    editable: isEditableRow,
    cellRenderer: TooltipRenderer,
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    hide: true,
    suppressPaste: false,
};

const quotedHeading = {
    colId: 'quoted',
    headerName: 'Quoted',
    field: 'quoted',
    editable: isEditableRow,
    valueFormatter: QuotedFormatter,
    cellEditorFramework: SelectEditor,
    keyCreator: QuotedKeyCreator,
    enableRowGroup: true,
    cellEditorParams: {
        values: ['Y', 'N'],
        formatValue: QuotedFieldFormatter,
    },
    suppressKeyboardEvent: allowUpAndDownOnEdit(),
    width: 67,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
    },
    type: ['privatable'],
};

const commissionHeading = {
    colId: 'commission',
    headerName: 'Commission',
    field: 'commission',
    editable: isEditableRow,
    cellEditorFramework: CommissionEditor,
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    cellRenderer: (commission) =>
        TooltipRenderer({ value: commission.valueFormatted }),
    valueFormatter: CommissionFormatter,
    equals: defaultObjEquals,
    keyCreator: CommissionKeyCreator,
    comparator: CommissionComparator,
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
    width: 100,
};

const parcelsHeading = {
    colId: 'parcels',
    headerName: 'Parcels',
    field: 'parcels',
    editable: isEditableRow,
    cellEditorFramework: ParcelsEditor,
    type: ['privatable'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
    width: 100,
    hide: true,
};

const directionHeading = {
    colId: 'direction',
    headerName: 'Direction',
    field: 'direction',
    editable: false,
    valueGetter: DirectionValueGetter,
    enableRowGroup: true,
    keyCreator: ({ value }) => {
        if (!value) {
            return unassignedDirectionText;
        }
        return value;
    },
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
    hide: true,
    width: 67,
};

const deliveryZoneHeading = {
    colId: 'deliveryZones',
    headerName: 'Delivery Z',
    field: 'deliveryZones',
    enableRowGroup: false,
    editable: false,
    cellEditorFramework: ZoneEditor,
    suppressKeyboardEvent: suppressOnEdit(),
    comparator: ZoneComparator,
    keyCreator: ZoneKeyCreator,
    valueFormatter: (params) =>
        formatDisplayZones(
            params.value,
            params.data?.deliveryZone,
            'deliveryZones'
        ),
    filter: 'zonesFilter',
    type: ['privatable'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
    width: 100,
};

const defaults = [
    checkboxHeading,
    privacyHeading,
    groupName,
    reportedDateHeading,
    updatedTimeHeading,
    updatedByHeading,
    chartererHeading,
    typeHeading,
    cargoQuantityPartsHeading,
    vesselNameHeadingForOrders,
    salePriceHeading,
    saleDateHeading,
    cargoPartsHeading,
    orderDeliveryTermHeading,
    deliveryLocationHeading,
    loadLocationHeading,
    loadZoneHeading,
    dischargeLocationHeading,
    orderRedeliveryTermHeading,
    redeliveryLocationHeading,
    freightPortBasisHeading,
    nearForwardHeading,
    laycanHeading,
    laycanFromHeading,
    laycanToHeading,
    durationPartsHeading,
    hireExpiryHeading,
    vesselCategoryHeading,
    commentsHeading,
    privateCommentsHeading,
    offersHeading,
    opportunityHeading,
    areaHeading,
    areaGearedHeading,
    brokerHeading,
    thirdPartyChartererHeading,
    chartererTypeHeading,
    thirdPartyBrokersHeading,
    getEastWestHeading('loadEW', 'Load E/W'),
    intraInterRegionalHeading,
    getEastWestHeading('dischEW', 'Disch E/W'),
    getEastWestHeading('deliveryEW', 'Delivery E/W'),
    getEastWestHeading('redeliveryEW', 'Redelivery E/W'),
    clarksonsBrokerHeadingForOrders,
    buyerHeading,
    privateFieldsHeading,
    rumouredHeading,
    quotedHeading,
    commissionHeading,
    directionHeading,
    parcelsHeading,
    stateHeading,
    orderStatusHeading,
    minRedelivery,
    maxRedelivery,
    ratesHeadingForOrders,
    thirdPartyOwnerHeadingForOrders,
    createdDateHeading,
    operatorHeading,
    deliveryZoneHeading,
];

const fakeHeadingDefaults = {
    1: defaults,
    6: defaults,
    98: defaults,
};

export { defaults as OrderHeadings };

export default class GroupHeadingApi {
    static getGroupHeadingDefaults() {
        return fakeHeadingDefaults;
    }

    static ensureGroupsHaveDefaults(groupIds) {
        const defaultIds = [1, 6, 98];
        const noOfDefaults = defaultIds.length;
        for (let index = 0; index < groupIds.length; index++) {
            const groupId = groupIds[index];

            if (!fakeHeadingDefaults.hasOwnProperty(groupId)) {
                let headingId = undefined;

                if (index < noOfDefaults) {
                    headingId = defaultIds[index];
                } else {
                    const randomId = Math.floor(
                        Math.random() * Math.floor(noOfDefaults)
                    );
                    headingId = defaultIds[randomId];
                }

                fakeHeadingDefaults[groupId] = fakeHeadingDefaults[headingId];
            }
        }
    }
}
